export const GAFAM_SERVICES = {
  categories: [
    {
      id: "messagerie",
      label: "Messagerie professionnelle",
      question: "Quelle solution utilisez-vous pour vos emails professionnels ?",
      icon: "mail",
      services: [
        { id: "gmail", name: "Gmail (Google)", provider: "Google", points: 15, critical: true },
        { id: "outlook", name: "Outlook / Microsoft 365", provider: "Microsoft", points: 15, critical: true },
        { id: "icloud_mail", name: "iCloud Mail", provider: "Apple", points: 10, critical: false }
      ],
      alternative: {
        service: "Infomaniak Mail",
        url: "https://oueb.it/produit/infomaniak-mail/",
        benefits: [
          "Hébergement en Suisse, respect total RGPD",
          "Aucune publicité, aucune analyse de vos emails",
          "Migration facile avec assistance incluse",
          "Calendrier et contacts intégrés"
        ]
      }
    },
    {
      id: "stockage",
      label: "Stockage et partage cloud",
      question: "Où stockez-vous et partagez-vous vos fichiers professionnels ?",
      icon: "cloud",
      services: [
        { id: "gdrive", name: "Google Drive", provider: "Google", points: 15, critical: true },
        { id: "onedrive", name: "OneDrive", provider: "Microsoft", points: 15, critical: true },
        { id: "dropbox", name: "Dropbox", provider: "Dropbox", points: 10, critical: false },
        { id: "icloud_drive", name: "iCloud Drive", provider: "Apple", points: 10, critical: false }
      ],
      alternative: {
        service: "kDrive",
        url: "https://oueb.it/produit/kdrive/",
        benefits: [
          "Stockage généreux selon l'offre",
          "Synchronisation automatique multi-appareils",
          "Collaboration en temps réel",
          "Vos fichiers restent vos fichiers, 100% souverain"
        ]
      }
    },
    {
      id: "visioconference",
      label: "Visioconférence",
      question: "Quel outil utilisez-vous pour vos visioconférences ?",
      icon: "video",
      services: [
        { id: "meet", name: "Google Meet", provider: "Google", points: 10, critical: false },
        { id: "teams_visio", name: "Microsoft Teams", provider: "Microsoft", points: 10, critical: false },
        { id: "zoom", name: "Zoom", provider: "Zoom", points: 10, critical: false }
      ],
      alternative: {
        service: "kMeet",
        url: "https://oueb.it/produit/kmeet/",
        benefits: [
          "Sans installation, directement dans le navigateur",
          "Jusqu'à 200 participants",
          "Enregistrement des réunions inclus",
          "Chiffrement de bout en bout"
        ]
      }
    },
    {
      id: "chat",
      label: "Messagerie instantanée d'équipe",
      question: "Quelle messagerie instantanée utilisez-vous en équipe ?",
      icon: "message",
      services: [
        { id: "google_chat", name: "Google Chat", provider: "Google", points: 10, critical: false },
        { id: "teams_chat", name: "Microsoft Teams (chat)", provider: "Microsoft", points: 10, critical: false },
        { id: "slack", name: "Slack", provider: "Salesforce", points: 10, critical: false }
      ],
      alternative: {
        service: "kChat",
        url: "https://oueb.it/produit/kchat/",
        benefits: [
          "Messagerie d'équipe souveraine",
          "Canaux publics et privés",
          "Partage de fichiers intégré",
          "Applications mobiles natives"
        ]
      }
    },
    {
      id: "bureautique",
      label: "Suite bureautique collaborative",
      question: "Quelle suite bureautique utilisez-vous ?",
      icon: "file-text",
      services: [
        { id: "google_workspace", name: "Google Workspace (Docs, Sheets, Slides)", provider: "Google", points: 15, critical: true },
        { id: "microsoft_365", name: "Microsoft 365 (Word, Excel, PowerPoint)", provider: "Microsoft", points: 15, critical: true },
        { id: "iwork", name: "Apple iWork", provider: "Apple", points: 10, critical: false }
      ],
      alternative: {
        service: "kSuite",
        url: "https://oueb.it/produit/ksuite/",
        benefits: [
          "Édition collaborative en temps réel",
          "Compatible avec les formats Office",
          "Basé sur OnlyOffice et Collabora",
          "Vos documents restent privés"
        ]
      }
    },
    {
      id: "transfert",
      label: "Transfert de fichiers volumineux",
      question: "Comment transférez-vous des fichiers volumineux ?",
      icon: "upload",
      services: [
        { id: "wetransfer", name: "WeTransfer", provider: "WeTransfer", points: 5, critical: false },
        { id: "dropbox_transfer", name: "Dropbox Transfer", provider: "Dropbox", points: 5, critical: false }
      ],
      alternative: {
        service: "SwissTransfer",
        url: "https://oueb.it/produit/swisstransfer/",
        benefits: [
          "Jusqu'à 50 GB par transfert (gratuit)",
          "Hébergement en Suisse",
          "Chiffrement des fichiers",
          "Aucune publicité, aucun tracking"
        ]
      }
    },
    {
      id: "calendrier",
      label: "Calendrier et contacts",
      question: "Quel calendrier utilisez-vous pour gérer vos agendas ?",
      icon: "calendar",
      services: [
        { id: "google_calendar", name: "Google Calendar", provider: "Google", points: 10, critical: false },
        { id: "outlook_calendar", name: "Outlook Calendar", provider: "Microsoft", points: 10, critical: false },
        { id: "icloud_calendar", name: "iCloud Calendar", provider: "Apple", points: 5, critical: false }
      ],
      alternative: {
        service: "Infomaniak Mail (calendrier intégré)",
        url: "https://oueb.it/produit/infomaniak-mail/",
        benefits: [
          "Calendrier intégré à votre messagerie",
          "Synchronisation CalDAV standard",
          "Partage de calendriers",
          "Compatible tous appareils"
        ]
      }
    },
    {
      id: "cloud_infrastructure",
      label: "Hébergement et infrastructure cloud",
      question: "Où hébergez-vous vos sites web et applications ?",
      icon: "server",
      services: [
        { id: "aws", name: "Amazon Web Services (AWS)", provider: "Amazon", points: 15, critical: true },
        { id: "gcp", name: "Google Cloud Platform (GCP)", provider: "Google", points: 15, critical: true },
        { id: "azure", name: "Microsoft Azure", provider: "Microsoft", points: 15, critical: true }
      ],
      alternative: {
        service: "Cloud public Infomaniak",
        url: "https://oueb.it/produit/hebergement-web/",
        benefits: [
          "Cloud souverain hébergé en Suisse",
          "Tarification simple et transparente",
          "Support technique en français",
          "Conformité RGPD garantie"
        ]
      }
    },
    {
      id: "partage_code",
      label: "Partage de texte/code",
      question: "Comment partagez-vous des extraits de texte ou de code ?",
      icon: "code",
      services: [
        { id: "google_keep", name: "Google Keep (partage)", provider: "Google", points: 5, critical: false },
        { id: "pastebin", name: "Pastebin et similaires", provider: "Autres", points: 5, critical: false }
      ],
      alternative: {
        service: "kPaste",
        url: "https://oueb.it/produit/kpaste/",
        benefits: [
          "Partage sécurisé de texte et code",
          "Expiration automatique configurable",
          "Hébergement suisse",
          "Protection par mot de passe"
        ]
      }
    }
  ]
};

export const getScoreLevel = (score) => {
  if (score <= 30) {
    return {
      level: "sovereign",
      label: "Souverain numérique",
      color: "#006241",
      bgColor: "bg-green-50",
      textColor: "text-[#006241]",
      borderColor: "border-[#006241]",
      message: "Félicitations ! Votre organisation a une excellente indépendance numérique."
    };
  } else if (score <= 70) {
    return {
      level: "moderate",
      label: "Dépendance modérée",
      color: "#FFAB00",
      bgColor: "bg-yellow-50",
      textColor: "text-yellow-700",
      borderColor: "border-yellow-500",
      message: "Votre organisation utilise quelques services GAFAM. Des alternatives existent !"
    };
  } else if (score <= 120) {
    return {
      level: "high",
      label: "Forte dépendance",
      color: "#FF6D00",
      bgColor: "bg-orange-50",
      textColor: "text-orange-700",
      borderColor: "border-orange-500",
      message: "Votre organisation est fortement dépendante des GAFAM. Il est temps d'agir !"
    };
  } else {
    return {
      level: "critical",
      label: "Dépendance critique",
      color: "#FF3D00",
      bgColor: "bg-red-50",
      textColor: "text-red-700",
      borderColor: "border-red-500",
      message: "Attention ! Votre organisation est très dépendante des GAFAM. Contactez-nous pour une migration."
    };
  }
};

export const MAX_SCORE = 175;
